import { useAuth0 } from "@auth0/auth0-react"
import { useEffect, useReducer } from "react"
import { EndOngoingSessionModalReducers } from "../store/reducers"
import { CONST_MAX_MESSAGE_LENGTH, EndOngoingSessionModalStates } from "../store/states"

export const useEndOngoingSessionModal = (chosenItem, refresh) => {
	const { user, getAccessTokenSilently } = useAuth0()
	const [state, dispatch] = useReducer(EndOngoingSessionModalReducers, EndOngoingSessionModalStates)

	const toggleModalHandler = () => {
		dispatch({ type: "TOGGLE_END_ONGOING_SESSION_MODAL" })
	}

	const endSessionHandler = () => {
		postEndOngoingSession()
	}

	const cancelHandler = () => {
		dispatch({ type: "CANCEL_END_ONGOING_SESSION" })
	}

	/**
	 * @function inputMessageHandler handle the user input message for end the ongoing session.
	 * @description
	 * The message will be displayed in the RAI end ongoing session modal.
	 * Once the message contains mutiple lines, the message will be displayed in the RAI end ongoing session modal with the line break.
	 * @param {obj} data
	 */
	const inputMessageHandler = (event, data) => {
		if (data.value.includes("\n")) {
			dispatch({ type: "SET_MESSAGE", payload: user.nickname + " :\n" + data.value })
		} else {
			dispatch({ type: "SET_MESSAGE", payload: user.nickname + " : " + data.value })
		}
	}

	const postEndOngoingSession = async () => {
		dispatch({ type: "IS_LOADING" })
		return fetch(process.env.REACT_APP_SESSION_ADDR + "/api/v2/device/endSession/" + chosenItem.serialnr, {
			method: "POST",
			headers: {
				"Authorization": "Bearer " + (await getAccessTokenSilently()),
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				msg: state.message
			})
		})
			.then((response) => {
				if (response.ok) {
					console.log("Posted Item successfully!")
					return response
				} else if (response.status === 400) {
					throw new Error("The request is invalid, please check the message length or try again later")
				} else if (response.status === 401) {
					throw new Error("You can not cancel the session of the device")
				} else if (response.status === 406) {
					throw new Error("The device is not in session, please refresh the page and try again")
				} else {
					throw new Error("Something went wrong, please try again later")
				}
			})
			.then(() => {
				dispatch({ type: "POST_SUCCESS" })
				// TODO: Await the response when successful end the ongoing session.
				// When the end the session successfully, the device status should be updated, but the MQTT message need to wait for the status response.
				// we will implement the ack/nack mechanism in the SM.
				// or implement the refresh button to refresh the page.
				// currently, we just refresh the page by waiting 5 seconds.
				setTimeout(() => {
					refresh()
				}, 5000)
			})
			.catch((err) => {
				dispatch({ type: "POST_ERROR", payload: err.message })
			})
	}

	useEffect(() => {
		dispatch({ type: "SET_OVER_MAX_MESSAGE_LENGTH", payload: state.message.length > CONST_MAX_MESSAGE_LENGTH })
	}, [state.message])

	return {
		state,
		toggleModalHandler,
		cancelHandler,
		inputMessageHandler,
		endSessionHandler
	}
}
